import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Loading from "../../../components/Loading";
import Data from '../../../../repository';
import { createProductSchema } from '../../../../validation/schemas';
import AppContext from "../../../../context";

import styles from '../../../../styles/Admin.module.scss';

function CreateProductForm() {
	const navigate = useNavigate();
	const context = useContext(AppContext);
	const [loading, setLoading] = useState(false);
	const [serverError, setServerError] = useState(null);
	const isHybridNew = context.domain?.businessType === 'hybrid-new';

	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm({
		resolver: yupResolver(createProductSchema),
		defaultValues: {
			credits: '',
			tokenType: 'general',
			description: '',
			price: '',
			enabled: true
		}
	});

	const onSubmit = async (data) => {
		setLoading(true);
		setServerError(null);

		try {
			await Data.createProduct({
				credits: Number(data.credits),
				tokenType: isHybridNew ? (data.tokenType || 'general') : 'general',
				description: data.description?.trim() || '',
				price: Number(data.price),
				enabled: data.enabled === 'true' || data.enabled === true
			});
			navigate("/admin/products");
		} catch (error) {
			setServerError(error.response?.data?.message || 'Failed to create product. Please try again.');
			setLoading(false);
		}
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
			<div>
				<p>Tokens: *</p>
				<input
					type="number"
					{...register('credits')}
					className={errors.credits ? 'input-error' : ''}
				/>
				<span className={styles.helpText}>
					Set tokens to 0 for one-off only purchases.
				</span>
				{errors.credits && <span className="form-field-error">{errors.credits.message}</span>}
			</div>

			{isHybridNew ? (
				<div>
					<p>Token Type:</p>
					<select {...register('tokenType')}>
						<option value="general">General</option>
						<option value="open_gym">Open Gym</option>
						<option value="class">Class</option>
					</select>
					<span className={styles.helpText}>
						Choose whether this pricing gives class tokens or open gym tokens.
					</span>
				</div>
			) : null}

			<div>
				<p>Description:</p>
				<input
					type="text"
					{...register('description')}
					className={errors.description ? 'input-error' : ''}
				/>
				{errors.description && <span className="form-field-error">{errors.description.message}</span>}
			</div>

			<div>
				<p>Price - in pence: *</p>
				<input
					type="number"
					{...register('price')}
					className={errors.price ? 'input-error' : ''}
				/>
				{errors.price && <span className="form-field-error">{errors.price.message}</span>}
			</div>

			<div>
				<p>Status:</p>
				<select {...register('enabled')}>
					<option value="true">Enabled</option>
					<option value="false">Disabled</option>
				</select>
			</div>

			{serverError && <p style={{ color: 'red' }}>{serverError}</p>}

			<button type="submit" className="btn btnPrimary" disabled={loading}>
				{loading ?
					<Loading button={true} />
					:
					`Create Product`
				}
			</button>
		</form>
	)
}

export default CreateProductForm;
